/* eslint-disable */

export const enum ProductChangelogItemType {
  feature = 1,
  criticalBug = 2,
  bugfix = 3,
  enhancement = 4,
}
